import { KnowledgeBase } from "../models/knowledge-base.model";
import {
  NavigationItem,
  Conversation,
  Message,
  User,
} from "../models";
import {
  Bot as BotIcon,
  BotMessageSquareIcon,
  Home,
  Search,
  Settings,
  UserCogIcon,
  Folders,
  MessageCircle
} from "lucide-angular";

export const PUBLIC_NAVIGATION_ITEMS: NavigationItem[] = [
  {
    id: "home",
    label: "Inicio",
    icon: Home,
    requiresAuth: false,
  }
];

export const RBAC_NAVIGATION_ITEMS: NavigationItem[] = [
  {
    id: "chatbot",
    label: "Chatbots",
    icon: BotMessageSquareIcon,
    isExpanded: false,
    requiresAuth: false,
    children: [
      {
        id: "chatbot/chats",
        label: "Chats",
        icon: MessageCircle,
        requiresAuth: false,
      },
      {
        id: "chatbot/conversations",
        label: "Visualizador de Conversaciones",
        icon: Search,
        requiresAuth: true,
      },
    ]
  },
  {
    id: "knowledge-base",
    label: "Bases de Conocimiento",
    icon: Folders,
    requiresAuth: true,
  },
  {
    id: "admin",
    label: "Admin",
    icon: Settings,
    isExpanded: false,
    requiresAuth: true,
    children: [
      {
        id: "management/chatbot",
        label: "Chatbots",
        icon: BotIcon,
        requiresAuth: true,
      },
      {
        id: "management/user",
        label: "Usuarios",
        icon: UserCogIcon,
        requiresAuth: true,
      }
    ],
  },
];

export const ROUTE_PERMISSION_MAP: { [key: string]: string[] } = {
  'chatbot': ['read_chatbot', 'run_chatbot', 'write_chatbot'],
  'chatbot/chats': ['read_chatbot', 'run_chatbot', 'write_chatbot'],
  'chatbot/chats/:code': ['run_chatbot', 'write_chatbot'],
  'management/chatbot': ['write_chatbot'],
  'management/user': ['write_users'],
  'chatbot/conversations': ['run_chatbotconversations'],
  'chatbot/conversations/:botId': ['run_chatbotconversations'],
  'knowledge-base': ['read_knowledgebase', 'write_knowledgebase'],
  'knowledge-base/:id': ['read_knowledgebase', 'write_knowledgebase'],
};

export const NAVIGATION_ITEMS: NavigationItem[] = [
  ...PUBLIC_NAVIGATION_ITEMS,
  ...RBAC_NAVIGATION_ITEMS,
];

export const MOCK_CONVERSATIONS: Conversation[] = [
  {
    id: "support-bot",
    name: "Support Bot",
    avatar: "S",
    lastMessage: "How can I help you today?",
    timestamp: "2m ago",
    status: "Active",
    bgColor: "bg-blue-500",
  },
  {
    id: "hr-assistant",
    name: "HR Assistant",
    avatar: "H",
    lastMessage: "Your leave request has been proc...",
    timestamp: "1h ago",
    status: "",
    bgColor: "bg-purple-500",
  },
  {
    id: "marketing-bot",
    name: "Marketing Bot",
    avatar: "M",
    lastMessage: "Here are some campaign ideas fo...",
    timestamp: "3h ago",
    status: "",
    bgColor: "bg-pink-500",
  },
];

export const MOCK_MESSAGES: Message[] = [
  {
    id: 1,
    sender: "bot",
    content:
      "Hello! I'm your Support Bot. I can help you with product questions, troubleshooting, and accessing our knowledge base. How can I assist you today?",
    timestamp: "2 minutes ago",
  },
  {
    id: 2,
    sender: "user",
    content:
      "Hi! I'm having trouble with the API integration. The authentication seems to be failing.",
    timestamp: "Just now",
  },
];

export const MOCK_KNOWLEDGE_BASES: KnowledgeBase[] = [
  {
    knowledgeBaseId: 1,
    code: "product-faqs",
    name: "Product FAQs",
    isTemporary: false,
    qaFilePath: "/files/qa/product-faqs.json",
    prodFilePath: "/files/prod/product-faqs.json",
    createdBy: 100,
    createdAt: "2024-01-01T10:00:00Z",
    qaSynchronizationStatus: null,
    prodSynchronizationStatus: null,
  },
  {
    knowledgeBaseId: 2,
    code: "internal-hr-policy",
    name: "Internal HR Policy",
    isTemporary: false,
    qaFilePath: "/files/qa/internal-hr-policy.json",
    prodFilePath: "/files/prod/internal-hr-policy.json",
    createdBy: 101,
    createdAt: "2024-01-02T11:00:00Z",
    qaSynchronizationStatus: null,
    prodSynchronizationStatus: null,
  },
  {
    knowledgeBaseId: 3,
    code: "api-documentation",
    name: "API Documentation",
    isTemporary: true,
    qaFilePath: null,
    prodFilePath: null,
    createdBy: 102,
    createdAt: "2024-01-03T12:00:00Z",
    qaSynchronizationStatus: null,
    prodSynchronizationStatus: null,
  },
];

export const MOCK_USER: User = {
  id: "admin",
  name: "Admin User",
  role: "Administrator",
  avatar: "U",
};
